const AsyncHooksContext = require('./asyncHooks');
const AsyncLocalStorageContext = require('./asyncLocalStorage');

module.exports = {
    AsyncLocalStorageContext,
    AsyncHooksContext
};
